package or.garden.manager.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class BedData(
    val id: Int,
    val userId: Int,
    val name: String,
    val width: Int,
    val length: Int,
    val type: String,
    val orientation: String
) {

    fun length() = if (orientation == "0") length else width
    fun width() = if (orientation == "0") width else length
    fun isHorizontal() = orientation == "0"
}